"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = require("lodash");
var mobx_1 = require("mobx");
var AccountCredentialsStore = /** @class */ (function () {
    function AccountCredentialsStore(notificationsStore, currentUserStore) {
        var _this = this;
        this.notificationsStore = notificationsStore;
        this.currentUserStore = currentUserStore;
        this.setEditUser = function (user) {
            _this.editUser = user;
        };
        this.toggleUserRole = function (user, roleId, state) {
            if (state) {
                _this.addUserRole(user, roleId);
            }
            else {
                _this.removeUserRole(user, roleId);
            }
        };
        this.setPendingDeleteUser = function (user) {
            _this.pendingDeleteUser = user;
        };
        this.setPendingDeleteInvite = function (invite) {
            _this.pendingDeleteInvite = invite;
        };
        this.deletePendingUser = function () {
            if (!_this.pendingDeleteUser) {
                return;
            }
            mobx_1.transaction(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var e_1;
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, window.__sdk__.auth.users.removeAccount(this.pendingDeleteUser._id, this.accountId)];
                        case 1:
                            _a.sent();
                            mobx_1.runInAction(function () {
                                _this.users = _this.users.filter(function (user) { return user !== _this.pendingDeleteUser; });
                            });
                            this.notificationsStore.pushSuccessNotification({
                                title: "Operation Complete",
                                text: "User deleted successfully",
                                timeout: 5000
                            });
                            return [3 /*break*/, 3];
                        case 2:
                            e_1 = _a.sent();
                            this.notificationsStore.pushErrorNotification({
                                title: "Operation Failed",
                                text: "Failed to delete user",
                                timeout: 5000
                            });
                            return [3 /*break*/, 3];
                        case 3:
                            mobx_1.runInAction(function () {
                                _this.pendingDeleteUser = null;
                            });
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        this.deletePendingInvite = function () {
            if (!_this.pendingDeleteInvite) {
                return;
            }
            mobx_1.transaction(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var e_2;
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, window.__sdk__.auth.invitations.removeAccountInvitation(this.accountId, this.pendingDeleteInvite._id)];
                        case 1:
                            _a.sent();
                            mobx_1.runInAction(function () {
                                _this.invitations = _this.invitations.filter(function (invite) { return invite !== _this.pendingDeleteInvite; });
                            });
                            this.notificationsStore.pushSuccessNotification({
                                title: "Operation Complete",
                                text: "Invitation deleted successfully",
                                timeout: 5000
                            });
                            return [3 /*break*/, 3];
                        case 2:
                            e_2 = _a.sent();
                            this.notificationsStore.pushErrorNotification({
                                title: "Operation Failed",
                                text: "Failed to delete invitation",
                                timeout: 5000
                            });
                            return [3 /*break*/, 3];
                        case 3:
                            mobx_1.runInAction(function () {
                                _this.pendingDeleteInvite = null;
                            });
                            return [2 /*return*/];
                    }
                });
            }); });
        };
    }
    AccountCredentialsStore.prototype.reset = function () {
        var _this = this;
        mobx_1.transaction(function () {
            _this.isLoading = false;
            _this.loadError = false;
            _this.accountId = null;
            _this.users = [];
            _this.invitations = [];
            _this.roles = [];
            _this.organizations = [];
            _this.indexOrganizations = {};
            _this.editUser = null;
            _this.pendingDeleteUser = null;
            _this.pendingDeleteInvite = null;
        });
    };
    AccountCredentialsStore.prototype.initialize = function (id) {
        var _this = this;
        mobx_1.transaction(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var promises, _a, users_1, invitations_1, roles_1, organization_1, e_3;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        this.loadError = false;
                        this.accountId = id;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        promises = [
                            window.__sdk__.auth.users.getByAccountId(id),
                            window.__sdk__.auth.invitations.getByAccountId(id),
                            window.__sdk__.auth.roles.getRoles()
                        ];
                        if (this.isVidazooOrganization) {
                            promises.push(window.__sdk__.auth.organizations.getOrganizations());
                        }
                        return [4 /*yield*/, Promise.all(promises)];
                    case 2:
                        _a = _b.sent(), users_1 = _a[0], invitations_1 = _a[1], roles_1 = _a[2], organization_1 = _a[3];
                        if (!(this.currentUserStore.isRootAdmin() || this.currentUserStore.isInviteVidazoo())) {
                            organization_1.results = organization_1.results.filter(function (org) { return (org.name !== "vidazoo"); });
                        }
                        mobx_1.runInAction(function () {
                            _this.users = users_1;
                            _this.invitations = invitations_1;
                            _this.organizations = organization_1 ? organization_1.results.map(function (item) { return ({ _id: item._id, name: item.name }); }) : [];
                            _this.indexOrganizations = organization_1 ? _.keyBy(organization_1.results, "_id") : {};
                            _this.roles = roles_1;
                            _this.isLoading = false;
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _b.sent();
                        mobx_1.runInAction(function () {
                            _this.isLoading = false;
                            _this.loadError = true;
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); });
    };
    AccountCredentialsStore.prototype.addUserRole = function (user, roleId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var role, e_4;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        role = this.getRole(roleId);
                        if (!role) return [3 /*break*/, 2];
                        user.scopes[0].roles = user.scopes[0].roles.concat([role]);
                        return [4 /*yield*/, window.__sdk__.auth.users.addRole(user._id, roleId)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        e_4 = _a.sent();
                        mobx_1.runInAction(function () {
                            user.scopes[0].roles = user.scopes[0].roles.filter(function (x) { return x._id !== roleId; });
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AccountCredentialsStore.prototype.removeUserRole = function (user, roleId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_5;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        user.scopes[0].roles = user.scopes[0].roles.filter(function (x) { return x._id !== roleId; });
                        return [4 /*yield*/, window.__sdk__.auth.users.removeRole(user._id, roleId)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_5 = _a.sent();
                        mobx_1.runInAction(function () {
                            var role = _this.getRole(roleId);
                            user.scopes[0].roles = user.scopes[0].roles.concat([role]);
                        });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AccountCredentialsStore.prototype.unblockUser = function (user) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_6;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, window.__sdk__.auth.users.unblockUser(user._id)];
                    case 1:
                        _a.sent();
                        mobx_1.runInAction(function () {
                            user.block = false;
                            user.blockReason = "";
                        });
                        this.notificationsStore.pushSuccessNotification({
                            title: "Operation Complete",
                            text: "Unblock user",
                            timeout: 5000
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        e_6 = _a.sent();
                        this.notificationsStore.pushErrorNotification({
                            title: "Operation Failed",
                            text: "Failed to unblock user",
                            timeout: 5000
                        });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AccountCredentialsStore.prototype.sendInvitation = function (email, roles, organization) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var invitation_1, e_7;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, window.__sdk__.auth.invitations.sendAccountInvitation(this.accountId, email, roles, organization, window.location.origin)];
                    case 1:
                        invitation_1 = _a.sent();
                        if (!invitation_1.addScopeToUser) {
                            mobx_1.runInAction(function () {
                                _this.invitations = _this.invitations.concat([invitation_1]);
                            });
                            this.notificationsStore.pushSuccessNotification({
                                title: "Operation Complete",
                                text: "Invitation sent successfully to <b>" + email + "</b>",
                                timeout: 5000
                            });
                        }
                        else {
                            this.notificationsStore.pushSuccessNotification({
                                title: "Operation Complete",
                                text: "This account successfully added to the user",
                                timeout: 5000
                            });
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_7 = _a.sent();
                        this.notificationsStore.pushErrorNotification({
                            title: "Operation Failed",
                            text: "Failed to send invitation to <b>" + email + "</b>",
                            timeout: 5000
                        });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AccountCredentialsStore.prototype.getRole = function (roleId) {
        return _.find(this.roles, function (role) { return role._id === roleId; });
    };
    Object.defineProperty(AccountCredentialsStore.prototype, "isVidazooOrganization", {
        get: function () {
            return this.currentUserStore.isVidazooOrganization || false;
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], AccountCredentialsStore.prototype, "accountId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], AccountCredentialsStore.prototype, "users", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], AccountCredentialsStore.prototype, "invitations", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], AccountCredentialsStore.prototype, "roles", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], AccountCredentialsStore.prototype, "organizations", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], AccountCredentialsStore.prototype, "indexOrganizations", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], AccountCredentialsStore.prototype, "isLoading", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], AccountCredentialsStore.prototype, "loadError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], AccountCredentialsStore.prototype, "editUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], AccountCredentialsStore.prototype, "pendingDeleteUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], AccountCredentialsStore.prototype, "pendingDeleteInvite", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], AccountCredentialsStore.prototype, "reset", null);
    tslib_1.__decorate([
        mobx_1.action
    ], AccountCredentialsStore.prototype, "initialize", null);
    tslib_1.__decorate([
        mobx_1.action
    ], AccountCredentialsStore.prototype, "setEditUser", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], AccountCredentialsStore.prototype, "toggleUserRole", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], AccountCredentialsStore.prototype, "addUserRole", null);
    tslib_1.__decorate([
        mobx_1.action
    ], AccountCredentialsStore.prototype, "removeUserRole", null);
    tslib_1.__decorate([
        mobx_1.action
    ], AccountCredentialsStore.prototype, "unblockUser", null);
    tslib_1.__decorate([
        mobx_1.action
    ], AccountCredentialsStore.prototype, "setPendingDeleteUser", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], AccountCredentialsStore.prototype, "setPendingDeleteInvite", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], AccountCredentialsStore.prototype, "deletePendingUser", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], AccountCredentialsStore.prototype, "deletePendingInvite", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], AccountCredentialsStore.prototype, "sendInvitation", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], AccountCredentialsStore.prototype, "isVidazooOrganization", null);
    return AccountCredentialsStore;
}());
exports.default = AccountCredentialsStore;
